import { removeNumberSeparators } from "utils/stringHelper";

export const isNumberString = (number: string) => /^[0-9\b]+$/.test(removeNumberSeparators(number));
